import { VoterStatusResponse } from '../typings';

export const MOCK_VOTER_STATUS: VoterStatusResponse = {
  voter_email: 'test@test.pl',
  vote_submitted: false,
  voted_for: 'voted@test.pl',
};
